module.exports = __webpack_public_path__ + "img/Santander.5412a721.svg";